import { useEffect, useLayoutEffect, useRef } from 'react';
import {
  captureBeerIngestionScrollPosition,
  readBeerIngestionScrollPosition,
  restoreBeerIngestionScrollPosition,
} from '../utils/brewery/beerIngestionScrollPosition';

function useBeerIngestionScrollRestore({ hasRows, loading, usState }) {
  const didRestoreRef = useRef(false);

  useEffect(() => {
    didRestoreRef.current = false;
  }, [usState]);

  useLayoutEffect(() => {
    if (loading || !hasRows || didRestoreRef.current) {
      return;
    }
    didRestoreRef.current = true;
    const stored = readBeerIngestionScrollPosition();
    if (!stored || stored.usState !== usState) {
      return;
    }
    restoreBeerIngestionScrollPosition(stored);
  }, [hasRows, loading, usState]);

  useEffect(() => {
    return () => {
      captureBeerIngestionScrollPosition({ usState });
    };
  }, [usState]);
}

export default useBeerIngestionScrollRestore;
